import React, { Fragment, useContext, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { InteractiveDiv } from 'formlabs-web-components/Wrapper';

import ModalContext from './ModalContext';

import './Overlay.module.css';

const ModalRoot = () => {
  const { component: Component, props, overlayType, hideModal } = useContext(
    ModalContext
  );
  const { t } = useTranslation();
  const ref = useRef();

  useEffect(() => {
    if (ref.current) {
      const previousFocus = document.activeElement;
      ref.current.focus();
      return () => previousFocus.focus();
    }
  });

  if (!Component) {
    return null;
  }

  const overlay =
    overlayType === 'touchclose' ? (
      <div
        styleName="overlay"
        onMouseEnter={hideModal}
        onTouchStart={hideModal}
      />
    ) : (
      <InteractiveDiv
        styleName="blind"
        handler={hideModal}
        handleTab={true}
        aria-label={t('Close modal window')}
      />
    );

  return (
    <Fragment>
      <Component ref={ref} {...props} />
      {overlay}
    </Fragment>
  );
};

export default ModalRoot;
